import React from 'react';
import Header from '../components/Header';
import DemoSection from '../components/DemoSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const DemoPage = () => {
  const seoData = {
    title: 'Demo y Prueba Gratuita',
    description: 'Solicita una demo gratuita de Runamatic. Descubre cómo automatizar tu atención al cliente con nuestra plataforma. Prueba sin compromiso.',
    keywords: 'demo runamatic, prueba gratuita, demo automatización, prueba chatbot, demo gratuita atención cliente',
    canonical: '/demo',
    ogTitle: 'Demo Gratuita - Runamatic',
    ogDescription: 'Solicita tu demo gratuita y descubre cómo automatizar tu negocio. Sin compromiso, resultados garantizados.',
    schema: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Demo Gratuita Runamatic",
      "description": "Demostración gratuita de la plataforma de automatización",
      "provider": {
        "@type": "Organization",
        "name": "Runamatic",
        "url": "https://runamatic.io"
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "description": "Demo gratuita sin compromiso"
      }
    }
  };

  return (
    <>
      <SEO {...seoData} />
      <Header />
      <main>
        <DemoSection standalone />
      </main>
      <Footer />
    </>
  );
};

export default DemoPage; 